import React from 'react';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import particlesConfig from '../Shared/pr-s-black';
import '../Assets/Stylesheets/Pages/Aboutus.scss';

export default function Aboutus() {
  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  return (
    <div className="aboutus-page">
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={particlesConfig}
        className="particles-background"
      />
      <div className="aboutus-content">
        <h1>About TRND</h1>
        
        <section className="aboutus-section">
          <h2>Our Journey</h2>
          <p>TRND is an organization that evolved into the social media and marketing industry for over a decade. Over the years we develop many marketing tools and created many relations with business owners and marketing business. Our goal is to combine all our knowledge into one platform.</p>
        </section>

        <section className="aboutus-section">
          <h2>Our Mission</h2>
          <p>At TRND, we're committed to revolutionizing the digital marketing landscape by providing innovative solutions that bridge the gap between traditional marketing and cutting-edge technology. Our mission is to empower businesses of all sizes with the tools and expertise they need to thrive in the digital age.</p>
        </section>

        <section className="aboutus-section">
          <h2>Our Expertise</h2>
          <div className="expertise-grid">
            <div className="expertise-item">
              <h3>Digital Marketing</h3>
              <p>Comprehensive digital marketing strategies tailored to your business needs.</p>
            </div>
            <div className="expertise-item">
              <h3>Social Media Management</h3>
              <p>Expert social media management and growth strategies.</p>
            </div>
            <div className="expertise-item">
              <h3>Content Creation</h3>
              <p>High-quality, engaging content that resonates with your audience.</p>
            </div>
            <div className="expertise-item">
              <h3>Marketing Tools</h3>
              <p>Innovative marketing tools designed to maximize your ROI.</p>
            </div>
          </div>
        </section>

        <section className="aboutus-section">
          <h2>Our Values</h2>
          <ul className="values-list">
            <li>Innovation in Marketing Solutions</li>
            <li>Client-Focused Approach</li>
            <li>Continuous Learning and Improvement</li>
            <li>Transparency and Integrity</li>
            <li>Results-Driven Strategies</li>
          </ul>
        </section>
      </div>
    </div>
  );
}
